/**
 * @file Telegram 服務 API
 * @description 提供 Telegram 機器人相關的 API 方法，如發送訊息等功能
 */
import { post } from './sub_services/base';
import apiPath from './api.path';
import config from 'config/config';
import ExceptionHandleService from 'utils/exceptionHandler';

const _EHS = new ExceptionHandleService({
  _NAME: 'services/telegram.ts',
  _NOTICE: 'telegram api'
});

/** Telegram 訊息請求參數介面 */
export interface TelegramMsgParams {
  message: string;
  [key: string]: unknown;
}

/** [POST]發送 Telegram 訊息 */
const postTelegramMsg = async (params: TelegramMsgParams): Promise<unknown> => {
  try {
    const url = `${config.SERVER_POINT}${apiPath.tg.postTelegramMsg}`;
    const result = await post(url, params);
    return result;
  } catch (error) {
    _EHS.errorReport(error, 'postTelegramMsg', _EHS._LEVEL.ERROR);
    return Promise.reject(error);
  }
};

export default {
  postTelegramMsg
};
